// Font Awesome's global icon registry. It exists only for icons that arrive as a CSS class
// string instead of a component prop: dom.watch() below rewrites those <i> tags into SVGs,
// and it can only find an icon that library.add() registered.
//
// This is NOT the app's icon list. App icons live in app/data/app_icons.js, which imports its
// icon objects directly and needs nothing from here.
//
// Only two things still produce class-string icons, which is why this list is short:
//   1. Buefy. main.js configures it with defaultIconPack 'fas' and no icon component, so it
//      renders <i class="fas fa-..."> from its own templates. Of the Buefy components this app
//      uses, only b-input (status icons), b-numberinput (plus/minus), b-datepicker (prev/next),
//      b-notification (icon by type), b-tag (close-icon) and b-icon render one. b-checkbox,
//      b-switch, b-radio, b-upload, b-loading and b-modal draw theirs in CSS. Buefy translates
//      some names on the way (chevron-left -> angle-left, information -> info-circle,
//      alert-circle -> exclamation-circle, menu-down -> caret-down), so the names below are the
//      translated ones. EM-719 removes Buefy, and with it most of this file.
//   2. IntegrationWarning.vue, which renders integrations.icon_class straight from the API.
//      Supervisors edit that field as free text; today it only ever holds 'fas fa-rotate' or
//      'fab fa-salesforce'. A value outside this list renders nothing, so add it here.
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faCaretDown,
  faCaretUp,
  faCheck,
  faEllipsisVertical,
  faExclamationCircle,
  faExclamationTriangle,
  faEyeSlash,
  faInfoCircle,
  faMinus,
  faPlus,
  faRotate,
  faTimesCircle,
  faTrashCan,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import { faSalesforce } from '@fortawesome/free-brands-svg-icons';

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faCaretDown,
  faCaretUp,
  faCheck,
  faEllipsisVertical,
  faExclamationCircle,
  faExclamationTriangle,
  faEyeSlash,
  faInfoCircle,
  faMinus,
  faPlus,
  faRotate,
  faSalesforce,
  faTimesCircle,
  faTrashCan,
  faUpload,
);

dom.watch();
